import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import 'hammerjs'

platformBrowserDynamic().bootstrapModule(AppModule)
